// extracted by mini-css-extract-plugin
export default {"uploadCodeVersion":"src-pages-SalesCannelVersion-SalesChannelSettings-SalesChannelMiniProgramSetting-Components-UploadCodeVersion-css-module__uploadCodeVersion--37x+l"};